import React from 'react';
import PropTypes from 'prop-types';
import { Deferred } from 'simply-deferred';

import Popover from '../../gd-components/gd-popover/popover.tsx';
import Checkbox from 'core/gd-components/checkbox/checkbox.tsx';

import HintPopover from '../hint-popover/hint-popover';
import {ItemIcon} from "core/gd/const/item-icon/item-icon";

const props = {

    value: PropTypes.number,
    values: PropTypes.array,
    multiselect: PropTypes.bool,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    fitSelectorWidth: PropTypes.bool,

    // options
    allowedTaskTypes: PropTypes.array, // currently not in use should be used when no projectId is passed
    projectId: PropTypes.string,


    // underline
    underlined: PropTypes.oneOf(['on-hover', 'always', 'never']),  // if set will show border bottom for the value

    // look and feel
    renderValue: PropTypes.oneOf(['circle-btn-28', 'form', 'selector', 'func']).isRequired, // render value view name
    renderValueFunc: PropTypes.func,        // func for external render function if passed used to render instead of default

    // form - if passed component will act as form element
    form: PropTypes.object,
    name: PropTypes.string,

    // No task type options
    canHaveNoValue: PropTypes.bool,         // if true we have support "no value" as a selector
    noValueLabel: PropTypes.string,         // Text that will appear for "no-value" option
    noValueValue: PropTypes.any,         // Text that will appear for "no-value" option

    // Callbacks
    onUserSelect: PropTypes.func,
    onTogglePopover: PropTypes.func,        // event when popover opens/closes

    // popover options
    popoverClass: PropTypes.string,
    attachment: PropTypes.string,
    targetAttachment: PropTypes.string,
    offset: PropTypes.string,

};


const defaultProps = {
    placeholder: 'Task type',
    multiselect: false,
    canHaveNoValue: false,
    disabled: false,

    attachment: 'top center',
    targetAttachment: 'bottom center',
};


class SelectTaskType extends React.Component {

    constructor(props) {
        super(props);

        const companyTaskTypes = gd.session.taskTypes.filterByCompany(gd.companyId)
        this.allTaskTypes = _.map(companyTaskTypes.models, tt => tt.id)

        let allowedTaskTypes = [];
        if (props.allowedTaskTypes) {
            allowedTaskTypes = props.allowedTaskTypes;
        } else if (props.projectId) {
            allowedTaskTypes = gd.session.projects.get(props.projectId).getInheritedTaskTypes();
        }

        let value = null;
        let values = [];

        if (props.multiselect) {
            if (props.form && props.form.getValue(props.name)) values = props.form.getValue(props.name);
            else if (props.values) values = props.values;
            else values = [];
        } else {
            if (props.form && props.form.getValue(props.name)) value = props.form.getValue(props.name);
            else if (props.value) value = props.value;
            else value = allowedTaskTypes[0];
        }

        this.state = {
            showPopover: false,
            value: value,
            values: values,
            allowedTaskTypes: allowedTaskTypes
        };

        this.togglePopover = this.togglePopover.bind(this);
    }

    UNSAFE_componentWillMount() {
        if (this.props.form) {
            this.props.form.registerFormComponent(this.props.name,this);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const {value, values, form, allowedTaskTypes, projectId} = nextProps;
        const updateState = {};

        if (nextProps.multiselect) {
            if (form) {
                const formValue = form.getValue(nextProps.name);
                if (formValue != this.state.values) {
                    updateState.values = formValue;
                }
                if (!allowedTaskTypes && projectId) {
                    updateState.allowedTaskTypes = gd.session.projects.get(projectId).getInheritedTaskTypes();
                }
            } else {
                if (typeof values !== 'undefined' && values !== this.state.values) {
                    updateState.values = values;
                }
            }
        } else {
            if (form) {
                const formValue = form.getValue(nextProps.name);
                if (formValue != this.state.value) {
                    updateState.value = formValue;
                }
                if (!allowedTaskTypes && projectId) {
                    updateState.allowedTaskTypes = gd.session.projects.get(projectId).getInheritedTaskTypes();
                }

            } else {
                if (typeof value !== 'undefined' && value !== this.state.value) {
                    updateState.value = value;
                }
            }
        }

        if (nextProps.projectId && nextProps.projectId!=this.props.projectId) {
            updateState.allowedTaskTypes = gd.session.projects.get(nextProps.projectId).getInheritedTaskTypes();
        } else if (nextProps.allowedTaskTypes && nextProps.allowedTaskTypes !== this.state.allowedTaskTypes) {
            updateState.allowedTaskTypes = nextProps.allowedTaskTypes;
        }


        if (Object.keys(updateState).length > 0) this.setState(updateState);
    }


    togglePopover() {
        if (!this.props.disabled) {
            const showPopover = !this.state.showPopover;
            this.setState({
                showPopover: showPopover
            },()=>{
                if (this.props.onTogglePopover) this.props.onTogglePopover(showPopover);
            });
        }
    }

    // close popover + set value
    hidePopover(selectedOption=null) {

        let showPopover = false;
        let value = this.state.value;
        let values = this.state.values;
        const stateChanged = new Deferred();

        if (selectedOption) {
            switch (selectedOption.type) {
                case 'task-type':
                    const ttId = selectedOption.taskType.id;
                    if (this.props.multiselect) {
                        const idx = values.indexOf(ttId);
                        if (idx == -1) values.push(ttId);
                        else values.splice(idx, 1);
                        showPopover = true;
                    } else {
                        value = ttId
                    }
                    break;
                case 'no-value':
                    value = this.props.noValueValue;
                    values = [];
                    break;
            }
        }

        this.setState({
            showPopover: showPopover,
            value: value,
            values: values,
        },()=>{
            stateChanged.resolve();
            if (this.props.onTogglePopover) this.props.onTogglePopover(false);
        });

        return stateChanged;
    }

    onOptionSelected(option) {
        if (option.disabled) return

        const stateChanged = this.hidePopover(option);

        const { name, multiselect, form, noValueValue, onUserSelect } = this.props;

        if (!form && !onUserSelect) return;

        const oldValue = this.state.value;

        switch (option.type) {
            case 'task-type':
                if (multiselect) {
                    stateChanged.done(() => {
                        form && form.onFormComponentValueChange(name, this.state.values);
                        onUserSelect && onUserSelect( this.state.values);
                    });
                } else {
                    const ttId = option.taskType.id;
                    if (ttId != oldValue) {
                        form && form.onFormComponentValueChange(name, ttId);
                        onUserSelect && onUserSelect(ttId);
                    }
                }
                break;
            case 'no-value':
                if (multiselect) {
                    form && form.onFormComponentValueChange(name, noValueValue);
                } else {
                    if (noValueValue != oldValue) {
                        form && form.onFormComponentValueChange(name, noValueValue);
                        onUserSelect && onUserSelect(noValueValue);
                    }
                }
                break;
        }
    }

    _getOptions() {
        // 2 types of options: no-value, taskType
        const selectOptions = []

        if (this.props.canHaveNoValue) {
            selectOptions.push({
                type: 'no-value'
            })
        }

        const allowedTaskTypes = this.state.allowedTaskTypes

        if (this.allTaskTypes) {
            _.map(this.allTaskTypes, ttId => {
                selectOptions.push({
                    type    : 'task-type',
                    disabled: !allowedTaskTypes.includes(ttId),
                    taskType: gd.session.taskTypes.get(ttId),
                })
            })
        }

        return selectOptions;
    }


    renderPopover() {
        if (!this.state.showPopover) return false;

        const { attachment, targetAttachment, offset, multiselect, fitSelectorWidth } = this.props;
        const popoverConstraints = [
            {
                to: "window",
                attachment: "together",
                pin: true
            }
        ];

        let content = [];
        const selectOptions = this._getOptions();

        if (selectOptions.length > 0) {

            selectOptions.forEach(option => {

                const classes = Classes('option action', {
                    'with-icon'     : option.type !== 'no-value',
                    'no-value'      : option.type === 'no-value',
                    'multiselect'   : multiselect,
                    'disabled'      : option.disabled
                });

                switch (option.type) {
                    case 'no-value':
                        content.push(
                            <div className={classes} key="no-value" onClick={this.onOptionSelected.bind(this, option)}>
                                {/*<span className="i5-subtasks icon" />*/}
                                {this.props.noValueLabel}
                            </div>
                        );
                        break;

                    case 'task-type':
                        const iconClass = Classes('action-icon', ItemIcon[option.taskType.icon], {disabled: option.disabled});
                        const isChecked = multiselect ? _.includes(this.state.values, option.taskType.id) : false;
                        content.push(
                            <div className={classes} key={option.taskType.id} onClick={this.onOptionSelected.bind(this, option)}>
                                {multiselect && <Checkbox size="normal-14" disabled={option.disabled} isChecked={isChecked}/> }
                                <div className={iconClass}></div>
                                {option.taskType.name}
                            </div>
                        );
                        break;
                }
            });

        } else {
            content = <div className="option empty">No task types found</div>
        }

        const popoverClasses = Classes('gd-select-task-type-popover', this.props.popoverClass, 'render-'+this.props.renderValue);

        return (
            <Popover popoverClass={popoverClasses}
                     className="gd-select-task-type-container"
                     attachment={attachment}
                     targetAttachment={targetAttachment}
                     constraints={popoverConstraints}
                     offset={offset}
                     onClickOutside={()=>{this.hidePopover()}}
                     fitTargetWidth={fitSelectorWidth}
                     heightRestriction="half-window-height">
                <div className="gd-popup-menu-items size-13">
                    {content}
                </div>
            </Popover>
        );

    }

    _renderValueSingle() {
        const { value } = this.state;

        const taskType = (value) ? gd.session.taskTypes.get(value) : false;

        let valueIcon = false;
        let valueLabel = this.props.placeholder;
        if (taskType) {
            valueIcon = ItemIcon[taskType.icon];
            valueLabel = taskType.name;
        }

        let res = false;
        let curValueClasses = Classes('cur-value', 'single-value', 'pop-target', {
            'no-value': !taskType
        });

        switch (this.props.renderValue) {

            case 'circle-btn-28':
                const taskIcon = value ? ItemIcon[taskType.icon] : 'i5-task';
                curValueClasses = Classes('cur-value','pop-target', taskIcon, 'icon', {
                    'no-value': !value
                });
                return <div className={curValueClasses} onClick={this.togglePopover.bind(this)} />;

            case 'form':
                return (
                    <div className={curValueClasses} onClick={this.togglePopover}>

                        {valueIcon && <span className={Classes('icon',valueIcon)}></span>}
                        <span>{valueLabel}</span>
                        <div className="arrow-icon i5-big-angle-down" />
                    </div>
                );


            case 'selector':
                curValueClasses = Classes('cur-value','pop-target', {
                    'no-value': !value
                });

                const iconClass = Classes('cur-value-icon',ItemIcon[taskType.icon]);

                return (
                    <div className={curValueClasses} onClick={this.togglePopover.bind(this)}>
                        <div className={iconClass}> </div>
                        {valueLabel}
                        <div className="arrow-icon i5-big-angle-down"> </div>
                    </div>
                );

            case 'func':
                res = this.props.renderValueFunc(value);
                break;
        }

        return (
            <div className={curValueClasses} onClick={this.togglePopover}>
                {res}
            </div>
        )
    }

    _renderValueMulti() {
        const { values } = this.state;
        const taskTypesCount = values && values.length ? values.length : 0;

        let result;

        if (taskTypesCount<1) {
            result = <span>{this.props.placeholder}</span>
        } else {
            result = values.map(taskTypeId=>{

                const taskType = gd.session.taskTypes.get(taskTypeId);

                return <div key={taskTypeId} className="item">{taskType.name}</div>
            })
        }

        let curValueClasses = Classes('cur-value', 'pop-target', 'multi-select', {
            'no-value': taskTypesCount < 1
        });

        switch (this.props.renderValue) {

            case 'form':

                return (
                    <div className={curValueClasses} onClick={this.togglePopover}>
                        {result}
                        <div className="cf"></div>
                        <div className="i5-big-angle-down" />
                    </div>
                );


            default:
                console.error("Task Type Select Multi Value Render not supported for", this.props.renderValue);
        }

    }

    renderValue() {
        return this.props.multiselect ? this._renderValueMulti() : this._renderValueSingle();
    }

    render() {
        const classes = Classes('gd-select-task-type', this.props.className,  'render-'+this.props.renderValue, {
            'underlined-always'     : this.props.underlined === 'always',
            'underlined-on-hover'   : this.props.underlined === 'on-hover',
            'is-disabled'           : this.props.disabled,
            'open'                  : this.state.showPopover
        });

        return (
            <div className={classes}>
                {this.renderValue()}
                {this.renderPopover()}

                {this.props.hint && !this.state.showPopover && <HintPopover parent={this} hint={this.props.hint}/>}
            </div>
        );
    }

}

SelectTaskType.propTypes = props;
SelectTaskType.defaultProps = defaultProps;

module.exports = SelectTaskType;
